export default __webpack_public_path__ + "static/media/MyPath2ASU_Hero.8eb9ba63.png";